import type { ProductPageVariantsCompProps } from './component';
import type { FC } from 'react';
import { lazy, memo, Suspense } from 'react';

const ComponentLoad = lazy(async () => await import('./component'));

const RateAnswerPopup: FC<ProductPageVariantsCompProps> = props => (
  <Suspense fallback={null}>
    <ComponentLoad {...props} />
  </Suspense>
);

export default memo(RateAnswerPopup);
